export default "__VITE_ASSET__DO4CT$mD__"